
export function getGridDataParams(appConfig) {
  const currentCustomer = appConfig.get('CurrentCustomer');
  const currentCustomerId = currentCustomer ? currentCustomer.Id : undefined;
  const gridDataParameters = {};

  if (currentCustomerId) {
    gridDataParameters.CurrentCustomerId = currentCustomerId;
  }

  return gridDataParameters;
}
